import React from "react";
import ReactDOM from "react-dom";
import App from "./js/react/scenes/";
import "./css/plyr/index.css";
import { FileManagerProps } from "js/react/scenes/components";
import { S3ContentSource } from "js/models";
import { S3Service } from "js/services";
import { initializeCloadinarySdk } from "js/services/Media";
// declare var window: any;

export type FileManagerOptions = Pick<
    FileManagerProps,
    | "contentSource"
    | "directoryHistory"
    | "onSelected"
    | "root"
    | "generatedFilesRoot"
    | "filterItems"
    | "cloudinary"
    | "selectionType"
    | "accept"
    | "defaultShare"
    | "shares"
>;

function render(props: FileManagerOptions, element: HTMLElement) {
    ReactDOM.render(<App {...props} />, element);
}

export function useFileManager(
    options: FileManagerOptions,
    element: HTMLElement
) {
    let p: FileManagerProps = {
        ...options,
        open: false,
        onOpenChanged: opened => {
            p = {
                ...p,
                open: opened
            };
            render(p, element);
        }
    };

    initializeCloadinarySdk(p.cloudinary.accountName);

    return {
        setOpen: (opened: boolean) => {
            p = {
                ...p,
                open: opened
            };
            render(p, element);
        }
    };
}

export function buildS3Service(contentSource: S3ContentSource) {
    return new S3Service(contentSource, {
        generatedFilesRoot: "",
        root: ""
    });
}

// window.eyeconicFileManager = {
//     useFileManager,
//     buildS3Service
// };
